import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { getStepDefinition, resolveResumeStep } from '@core/onboarding/onboarding-machine';
import { AccountService } from '@core/services/account/account';
import { AuthService } from '@core/services/auth/auth';
import { OnboardingStateService } from '@core/services/onboarding/onboarding-state';

const checkAvailability = async () => {
  const accountService = inject(AccountService);
  const authService = inject(AuthService);
  const onboardingStateService = inject(OnboardingStateService);
  const router = inject(Router);

  await accountService.awaitReady();
  await authService.awaitReady();
  await onboardingStateService.awaitReady();

  // Unauthenticated users should be handled by authGuard, not redirected to onboarding
  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['auth', 'login']);
  }

  if (accountService.availabilityResult()) {
    return true;
  }

  const state = onboardingStateService.state();
  if (state) {
    const def = getStepDefinition(resolveResumeStep(state));
    return def ? router.createUrlTree(def.route) : router.createUrlTree(['auth', 'login']);
  }

  return true;
};

export const availabilityGuard: CanActivateFn = () => checkAvailability();

export const availabilityChildGuard: CanActivateChildFn = () => checkAvailability();

export const isAvailableGuard: CanActivateFn = async () => {
  const accountService = inject(AccountService);
  const router = inject(Router);
  await accountService.awaitReady();
  return !accountService.availabilityResult() || router.createUrlTree(['home']);
};
